import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WindowShimModule } from '®shared/window-shim';

import { RedirectionService } from './redirection.service';

@NgModule({
  imports: [CommonModule, WindowShimModule],
  providers: [RedirectionService],
})
export class RedirectionModule {}
